import * as Yup from "yup";

export const validation = Yup.object().shape({
  name: Yup.string().required("กรุณากรอก"),
  // document_id: Yup.string().required("กรุณาเลือกข้อมูล"),
});
